import {Action} from '@ngrx/store';
import {GetGroupsSuccessAction} from '../actions/groups/get-groups-success-action';
import {GetGroupsErrorAction} from '../actions/groups/get-groups-error-action';
import {GroupsState} from '../states/groups-state';
import {UpdateGroupErrorAction} from '../actions/groups/update-group-error-action';
import {UpdateGroupAction} from '../actions/groups/update-group-action';
import {AddGroupErrorAction} from '../actions/groups/add-group-error-action';
import {DeleteGroupErrorAction} from '../actions/groups/delete-group-error-action';
import {AddGroupAction} from '../actions/groups/add-group-action';
import {DeleteGroupAction} from '../actions/groups/delete-group-action';
import {GetGroupsAction} from '../actions/groups/get-groups-action';
import {Deserialize, Serialize} from 'cerialize';

const initialState = new GroupsState();

export function GroupsReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: GroupsState = Deserialize(serializedState, GroupsState);

  switch (action.type) {
    case GetGroupsAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetGroupsSuccessAction.type:
      state.ready = true;
      state.groups = (<GetGroupsSuccessAction>action).groups;
      state.error = null;
      break;

    case GetGroupsErrorAction.type:
      state.ready = true;
      state.error = (<GetGroupsErrorAction>action).error;
      break;

    case AddGroupAction.type:
      state.ready = false;
      state.error = null;
      break;

    case AddGroupErrorAction.type:
      state.ready = true;
      state.error = (<AddGroupErrorAction>action).error;
      break;

    case UpdateGroupAction.type:
      state.ready = false;
      state.error = null;
      break;

    case UpdateGroupErrorAction.type:
      state.ready = true;
      state.error = (<UpdateGroupErrorAction>action).error;
      break;

    case DeleteGroupAction.type:
      state.ready = false;
      state.error = null;
      break;

    case DeleteGroupErrorAction.type:
      state.ready = true;
      state.error = (<DeleteGroupErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
